import * as React from "react";

const SvgComponent = (props) => (
  <svg
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M11.85 2.39a2.024 2.024 0 0 1 4.048 0v22.269a2.025 2.025 0 0 1-4.049 0V2.389Z"
      fill="currentColor"
    />
    <path
      d="M25.008 11.5a2.024 2.024 0 1 1 0 4.048H2.738a2.024 2.024 0 0 1 0-4.049h22.27Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgComponent;
